import { render, staticRenderFns } from "./header-template.vue?vue&type=template&id=4a71243e&"
import script from "./header-template.vue?vue&type=script&lang=ts&"
export * from "./header-template.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports